module.exports = __webpack_public_path__ + "static/media/homeIcon.0ed81d0d.svg";